import PropTypes from 'prop-types';
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { BigCalendarInTimeZone } from '../../Modules';
import moment from 'moment-timezone';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './DayView.scss';
import styles from './BigCalendar.scss';
import { withRouter } from 'found';
import BigCalendarUtils from '../../../lib/utils/bigCalendar';

const DayViewComponent = class DayView extends React.Component {
  static propTypes = {
    selectedDay: PropTypes.object.isRequired,
    updateSelectedDay: PropTypes.func.isRequired,
    close: PropTypes.func,
    router: PropTypes.object.isRequired,
    closeAvailabilityChecker: PropTypes.func,
    events: PropTypes.array,
    timeZone: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.nextDay = this.nextDay.bind(this);
    this.prevDay = this.prevDay.bind(this);
    this.selectEvent = this.selectEvent.bind(this);
  }

  generateEventId() {
    return `${Math.random().toString(36)}00000000000000000`.slice(2, 16 + 2);
  }

  nextDay() {
    this.props.updateSelectedDay(
      moment(this.props.selectedDay).add(1, 'days').toDate()
    );
  }

  prevDay() {
    this.props.updateSelectedDay(
      moment(this.props.selectedDay).subtract(1, 'days').toDate()
    );
  }

  selectEvent(event) {
    this.props.router.push(`/events/${event.id}`);
    setTimeout(() => {
      this.props.close();
      if (this.props.closeAvailabilityChecker) this.props.closeAvailabilityChecker();
    }, 0);
  }

  render() {
    const events = BigCalendarUtils.getFlattenedEventSegments(
      this.props.events
    );
    const timeZone = this.props.timeZone || moment.tz.guess();
    const Event = ({ event }) =>
      <span>
        <strong>
          {event.title}
        </strong>
      </span>;

    let firstEvent = moment(this.props.selectedDay).endOf('day');
    events.slice().map(event => {
      if (moment(event.start).isSame(firstEvent, 'day')) {
        firstEvent = moment.min(firstEvent, moment(event.start));
      }
      return event;
    });
    if (events.length === 0) {
      firstEvent = moment(this.props.selectedDay).startOf('day');
    }

    return (
      <div style={{ margin: '2em 0' }}>
        <div className={styles.timepicker}>
          <span
            className={[styles.timepickerButton, styles.timepickerPrev].join(
              ' '
            )}
            onClick={this.prevDay}
          />
          <span
            className={[styles.timepickerButton, styles.timepickerNext].join(
              ' '
            )}
            onClick={this.nextDay}
          />
          <p className={styles.selectedDay}>
            {moment(this.props.selectedDay).format('dddd')}
          </p>
          <p className={styles.selectedDate}>
            {moment(this.props.selectedDay).format('MMMM Do, YYYY')}
          </p>
          <BigCalendarInTimeZone
            date={this.props.selectedDay}
            components={{ event: Event }}
            events={events}
            timeZone={timeZone}
            showMultiDayTimes
            formats={{ timeGutterFormat: 'h A', dayFormat: ' ' }}
            timeslots={2}
            view='day'
            onView={() => {}}
            onNavigate={() => {}}
            toolbar={false}
            defaultDate={this.props.selectedDay}
            onSelectEvent={this.selectEvent}
            eventPropGetter={BigCalendarUtils.eventPropGetter}
            style={{ height: '360px' }}
            className='dayView'
            key={firstEvent.toDate()}
            scrollToTime={firstEvent.toDate()}
          />
        </div>
      </div>
    );
  }
};

export default withRouter(DayViewComponent);



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/DayView.js